import cn from 'classnames'
import React, { memo, useState } from 'react'

import CartSubContent from '../Cart/CartSubContent'
import { HtmlContentViewer } from '../HtmlContentViewer/HtmlContentViewer'

interface LongDescItemProps {
  longDescription: string
}

export const LongDescItem: React.FC<LongDescItemProps> = memo(({ longDescription = '' }) => {
  const [showMore, setShowMore] = useState(true)
  const [showmoreClassName, setShowmoreClassName] = useState('h-[90px] overflow-hidden')

  return (
    <CartSubContent className="html-show flex flex-col px-[1.875rem] mb-[2.0rem]">
      <HtmlContentViewer className={cn(showmoreClassName, 'body-des-html')} html={longDescription} />
      <div
        className="w-full text-[0.875rem] font-primary font-regular text-textdark leading-[19px] cursor-pointer"
        onClick={() => {
          showMore ? setShowmoreClassName('') : setShowmoreClassName('h-[74px] overflow-hidden')
          setShowMore(!showMore)
        }}
      >
        {showMore ? 'View more' : 'View less'}
      </div>
    </CartSubContent>
  )
})
